/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Who conducts question pacing for the active exam segment.
 */
export type OralExamDriver = (typeof OralExamDriver)[keyof typeof OralExamDriver];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamDriver = {
  lecturer: 'lecturer',
  examiner_agent: 'examiner_agent',
} as const;
